import {
  Typography,
  Card,
  CardHeader,
  CardContent,
  Tooltip,
} from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useAptorApi } from '../../../../Api';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { useIsMounted } from '../../../../Hooks/useIsMounted';
import { IGridQueryRequest, OrderDirection } from '../../../../Api/AptorApi';
import moment from 'moment';
import { Query } from '@material-table/core';
import { MTable } from '../../../../Components';
import {  ArrowForward } from '@material-ui/icons';

type UnacknowledgedChange = {
  id: number;
  number: string;
  effectiveFrom: Date;
  lawId: number;
  name: string;
  userId: number;
  userName: string;
  type: 'Law' | 'Requirement';
};

export const ChangeUnacknowledgedLaw = () => {
  const { api, abortController } = useAptorApi();
  const { formatMessage } = useIntl();
  const tableRef = React.useRef<any>(null);
    const isMounted = useIsMounted();
  useEffect(() => {
    if (isMounted) {
      tableRef.current && (tableRef.current as any).onQueryChange();
    }
  }, [tableRef, isMounted]);

   const handleDataFetch = useCallback(
      async (query: Query<UnacknowledgedChange>) => {
        return await api.searchlawUnacknowledgedChanges<UnacknowledgedChange>({
          orderDirection: query.orderDirection === 'desc' ? OrderDirection.Descending : OrderDirection.Ascending,
          orderBy: query.orderBy !== undefined ? query.orderBy.field : 'effectiveFrom',
          page: query.page,
          pageSize: query.pageSize,
          search: query.search,
          filters: {},
        } as IGridQueryRequest);
      },
      [api],
    );
  const renderDate = (date?: Date) => {
    return date ? moment(date).format('ll') : undefined;
  };

  return (
    <Card className='dashboar-unacknowledgedChange-card'>
      <CardHeader
        title={
          <Typography variant="h3">
            <FormattedMessage id="law-portal.statistics.sub-menu.changes.unacknowledged"></FormattedMessage>
          </Typography>
        }
        action={
          <Link to="/law-portal/our-laws/unacknowledged" style={{ textDecoration: 'none' }}>
            <Typography variant="h4" color="primary" style={{display:'flex',alignItems:'center',gap:'5px'}}>
              <FormattedMessage id="law-portal.dashboard.go-to-changes-to-acknowledge"></FormattedMessage><ArrowForward />
            </Typography>
          </Link>
        }
      />
      <CardContent>
         <MTable
                tableRef={tableRef}
                columns={[
                  {
                    title: formatMessage({ id: 'law-portal.our-laws.table.law' }),
                    field: 'name',
                  },
                  {
                    title: formatMessage({ id: 'law-portal.statistics.table.number' }),
                    field: 'number',
                    render: (row) => (
                      <Link to={`/law-portal/our-laws/${row.lawId}/changes`}>
                        {row.number}
                      </Link>
                    ),
                  },
                  {
                    title: formatMessage({ id: 'law-portal.statistics.table.effectiveFrom' }),
                    field: 'effectiveFrom',
                    render: (row) => renderDate(row.effectiveFrom),
                  },
                ]}
                data={handleDataFetch}
                options={{ 
                  toolbar: false, 
                  pageSize: 5,
                  headerStyle: {
                    backgroundColor: '#f5f5f5'
                  }
                }}
              />
      </CardContent>
    </Card>
  );
};
